import React, { useState, useEffect } from "react";
import { AiFillEye, AiFillGithub } from "react-icons/ai";
import { motion } from "framer-motion";
import ReactTooltip from "react-tooltip";

import { AppWrap, MotionWrap } from "../../wrapper";
// import { urlFor, client } from "../../client";
import { images } from "../../constants";
import "./Skills.scss";

const Skills = () => {
  const skills = [
    {
      name: "HTML5",
      bgColor: "",
      icon: images.html,
    },
    {
      name: "CSS3",
      bgColor: "",
      icon: images.css,
    },
    {
      name: "JavaScript",
      bgColor: "",
      icon: images.javascript,
    },
    {
      name: "Java",
      bgColor: "",
      icon: images.java,
    },
    {
      name: "React",
      bgColor: "",
      icon: images.react,
    },
    {
      name: "Redux",
      bgColor: "",
      icon: images.redux,
    },
    {
      name: "Sass",
      bgColor: "",
      icon: images.sass,
    },
    {
      name: "Figma",
      bgColor: "",
      icon: images.figma,
    },
    {
      name: "NodeJs",
      bgColor: "",
      icon: images.node,
    },
    {
      name: "Express",
      bgColor: "",
      icon: images.express,
    },
    {
      name: "MongoDB",
      bgColor: "",
      icon: images.mongo,
    },
    {
      name: "Adobe XD",
      bgColor: "",
      icon: images.xd,
    },
  ];

  const experiences = [
    {
      year: "2020",
      works: [
        {
          name: "Junior Teacher",
          company: "Lord Krishna Inter College",
          desc: "Taught 50+ students in learning process their potential. Took daily classes for 5th to 8th class students.",
        },
      ],
    },
  ];

  // const [experiences, setExperiences] = useState([]);
  // const [skills, setSkills] = useState([]);

  // useEffect(() => {
  //   const query = '*[_type == "experiences"]';
  //   const skillsQuery = '*[_type == "skills"]';

  //   client.fetch(query).then((data) => {
  //     setExperiences(data);
  //   });

  //   client.fetch(skillsQuery).then((data) => {
  //     setSkills(data);
  //   });
  // }, []);

  return (
    <>
      <h2 className="head-text">Skills</h2>

      <div className="app__skills-container">
        <motion.div className="app__skills-list">
          {skills.map((skill) => (
            <motion.div
              whileInView={{ opacity: [0, 1] }}
              transition={{ duration: 0.5 }}
              className="app__skills-item app__flex"
              key={skill.name}
            >
              <div
                className="app__flex"
                style={{ backgroundColor: skill.bgColor }}
              >
                <img src={skill.icon} alt={skill.name} />
              </div>
              <p className="p-text">{skill.name}</p>
            </motion.div>
          ))}
        </motion.div>

        {/* <div className="app__skills-exp">
          {experiences.map((experience) => (
            <motion.div className="app__skills-exp-item" key={experience.year}>
              <div className="app__skills-exp-year">
                <p className="bold-text">{experience.year}</p>
              </div>
              <motion.div className="app__skills-exp-works">
              
                {experience.works.map((work) => (
                  <>
                    <motion.div
                      whileInView={{ opacity: [0, 1] }}
                      transition={{ duration: 0.5 }}
                      className="app__skills-exp-work"
                      data-tip
                      data-for={work.name}
                      key={work.name}
                    >
                      <h4 className="bold-text">{work.name}</h4>
                      <p className="p-text">{work.company}</p>
                    </motion.div>
                    <ReactTooltip
                      id={work.name}
                      effect="solid"
                      arrowColor="#fff"
                      className="skills-tooltip"
                    >
                      {work.desc}
                    </ReactTooltip>
                  </>
                ))}
              </motion.div>
            </motion.div>
          ))}
        </div> */}
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Skills, "app__skills"),
  "skills",
  "app__whitebg"
);
